import angular from 'angular';

export default function resizableShift(
  Authentication,
  Utils,
  $document,
  $parse,
  $window,
  $compile
) {
  'ngInject';

  return {
    scope: true,
    link($scope, $element, $attrs) {
      const config = $scope.$eval($attrs.resizableShift);

      const leftHandle = $compile(
        angular.element('<div class="shift-left-handle" ng-hide="disabled"></div>')
      )($scope);
      const rightHandle = $compile(
        angular.element('<div class="shift-right-handle" ng-hide="disabled"></div>')
      )($scope);

      const resizableOnChanged = $parse($attrs.resizableOnChanged);
      const resizableOnChanging = $parse($attrs.resizableOnChanging);
      const minuteQuantum = Number($attrs.minuteQuantum) || 30;

      const visibleHours = Utils.getVisibleHoursRange(
        Authentication.user.orgSettings.visibleHoursStart,
        Authentication.user.orgSettings.visibleHoursEnd
      );
      const gridSize = visibleHours.length;

      // Resizing right side basically means setting up new dtend. dtend is based on the distance from the begining of calendar grid.
      // Therefore whenever we change operating hours start we have to include difference between 00:00 and target hour in calculations.
      const visibleMinutesGap = visibleHours[0] * 60;

      $scope.$watchCollection($attrs.resizableShift, (options) => {
        Object.assign($scope, options);
      });

      if (config.left) {
        $element.append(leftHandle);

        leftHandle.on('mousedown', (e) => {
          const initialWidth = $element.css('width');
          const initialLeft = $element.css('left');
          const computedWidth = parseFloat(
            $window.getComputedStyle($element[0]).width.slice(0, -2),
            10
          );
          const computedParentWidth = parseFloat(
            $window.getComputedStyle($element.parent()[0]).width.slice(0, -2),
            10
          );
          const computedLeftString = $window.getComputedStyle($element[0]).left;
          let computedLeft;

          if (/%$/.test(computedLeftString)) {
            computedLeft =
              (computedParentWidth * parseFloat(computedLeftString.slice(0, -1), 10)) / 100;
          } else {
            computedLeft = parseFloat(computedLeftString.slice(0, -2), 10);
          }

          const initialMouseX = e.clientX;
          let _hours = null;
          let _minutes = null;

          /* get sibling elements */
          let siblings = Array.prototype.slice
            .call($element[0].parentElement.querySelectorAll('[resizable-shift]'))
            .filter((elem) => elem !== $element[0]);

          /* filter only those in the same row */
          siblings = siblings.filter(
            (sibling) =>
              $window.getComputedStyle($element[0]).top === $window.getComputedStyle(sibling).top
          );

          siblings = siblings.map((sibling) => {
            const style = $window.getComputedStyle(sibling);
            let left = style.left;
            const width = Number(style.width.slice(0, -2));

            if (/%$/.test(left)) {
              left = (computedParentWidth * Number(left.slice(0, -1))) / 100;
            } else {
              left = Number(left.slice(0, -2));
            }

            return left + width;
          });

          siblings = siblings.filter((sibling) => sibling < computedLeft);

          siblings.push(0);
          const minLeft = Math.max(...siblings) + 4;

          const moveHandler = function moveHandler(moveEvent) {
            const mouseX = moveEvent.clientX;
            let diff = mouseX - initialMouseX;

            if (computedLeft + diff < minLeft) {
              diff += minLeft - computedLeft - diff;
            }

            if (computedWidth - diff <= computedParentWidth / gridSize) {
              diff = computedWidth - computedParentWidth / gridSize;
            }

            $element.css('width', `${computedWidth - diff}px`);
            $element.css('left', `${computedLeft + diff}px`);

            let newMinutes =
              Math.round((gridSize * 60 * (computedLeft + diff)) / computedParentWidth) +
              visibleMinutesGap;
            newMinutes = Math.round(newMinutes / minuteQuantum) * minuteQuantum;
            const newHours = Math.floor(newMinutes / 60);
            newMinutes -= newHours * 60;

            if (newHours !== _hours || newMinutes !== _minutes) {
              _hours = newHours;
              _minutes = newMinutes;
              $scope.$apply(() => {
                resizableOnChanging($scope, {
                  $hour: _hours,
                  $minute: _minutes,
                  $boundary: 'left',
                });
              });
            }
          };

          e.stopPropagation();
          e.preventDefault();
          $element.addClass('hovered');

          $document.on('mousemove', moveHandler);

          $document.one('mouseup', () => {
            $element.css('width', initialWidth);
            $element.css('left', initialLeft);
            $element.removeClass('hovered');
            $document.off('mousemove', moveHandler);

            if (_hours !== null) {
              $scope.$apply(() => {
                resizableOnChanged($scope, { $hour: _hours, $minute: _minutes, $boundary: 'left' });
              });
            }
          });
        });

        leftHandle.on('click', (e) => {
          e.stopPropagation();
        });
      }

      if (config.right) {
        $element.append(rightHandle);
        rightHandle.on('mousedown', (e) => {
          const initialWidth = $element.css('width');
          const computedWidth = parseFloat(
            $window.getComputedStyle($element[0]).width.slice(0, -2),
            10
          );
          const computedParentWidth = parseFloat(
            $window.getComputedStyle($element.parent()[0]).width.slice(0, -2),
            10
          );
          const computedLeftString = $window.getComputedStyle($element[0]).left;
          let computedLeft;

          if (/%$/.test(computedLeftString)) {
            computedLeft =
              (computedParentWidth * parseFloat(computedLeftString.slice(0, -1))) / 100;
          } else {
            computedLeft = parseFloat(computedLeftString.slice(0, -2), 10);
          }

          const initialMouseX = e.clientX;
          let _hours = null;
          let _minutes = null;

          /* get sibling elements */
          let siblings = Array.prototype.slice
            .call($element[0].parentElement.querySelectorAll('[resizable-shift]'))
            .filter((elem) => elem !== $element[0]);

          /* filter only those in the same row */
          siblings = siblings.filter(
            (sibling) =>
              $window.getComputedStyle($element[0]).top === $window.getComputedStyle(sibling).top
          );

          siblings = siblings.map((sibling) => {
            const style = $window.getComputedStyle(sibling);
            let left = style.left;
            if (/%$/.test(left)) {
              left = (computedParentWidth * Number(left.slice(0, -1))) / 100;
            } else {
              left = Number(left.slice(0, -2));
            }
            return left;
          });

          siblings = siblings.filter((sibling) => sibling > computedLeft + computedWidth);

          siblings.push(computedParentWidth);
          const maxRight = Math.min(...siblings) - 4;

          const moveHandler = function moveHandler(moveEvent) {
            const mouseX = moveEvent.clientX;
            let diff = mouseX - initialMouseX;

            // computedWidth -> width of shift before applying resize, computedLeft -> width from the start of the grid to the begining of shift box
            if (computedWidth + diff + computedLeft > maxRight) {
              diff = maxRight - computedLeft - computedWidth;
            }

            // computedParentWidth -> whole row width
            if (computedWidth + diff < computedParentWidth / gridSize) {
              diff = computedParentWidth / gridSize - computedWidth;
            }

            $element.css('width', `${computedWidth + diff}px`);

            let newMinutes =
              Math.round(
                (gridSize * 60 * (computedLeft + computedWidth + diff)) / computedParentWidth
              ) + visibleMinutesGap;
            newMinutes = Math.round(newMinutes / minuteQuantum) * minuteQuantum;
            const newHours = Math.floor(newMinutes / 60);
            newMinutes -= newHours * 60;

            if (newHours !== _hours || newMinutes !== _minutes) {
              _hours = newHours;
              _minutes = newMinutes;
              $scope.$apply(() => {
                resizableOnChanging($scope, {
                  $hour: _hours,
                  $minute: _minutes,
                  $boundary: 'right',
                });
              });
            }
          };

          e.stopPropagation();
          e.preventDefault();
          $element.addClass('hovered');

          $document.on('mousemove', moveHandler);

          $document.one('mouseup', () => {
            $element.css('width', initialWidth);
            $element.removeClass('hovered');
            $document.off('mousemove', moveHandler);

            if (_hours !== null && _minutes !== null) {
              $scope.$apply(() => {
                resizableOnChanged($scope, {
                  $hour: _hours,
                  $minute: _minutes,
                  $boundary: 'right',
                });
              });
            }
          });
        });

        rightHandle.on('click', (e) => {
          e.stopPropagation();
        });
      }
    },
  };
}
